const faqData = [
  {
    q: '黑料不打烊是什么？',
    a: '黑料不打烊是一个24小时持续更新的在线视频内容聚合平台，汇聚全网最新最热的黑料视频、每日大赛、娱乐八卦、综艺热点等多元内容，用户可随时随地免费高清观看，真正做到不打烊。',
  },
  {
    q: '黑料网是否需要注册或付费？',
    a: '完全不需要。黑料网所有内容均为免费观看，无需注册账号，无需任何付费订阅。打开即看，方便快捷，真正做到零门槛享受海量黑料在线视频内容。',
  },
  {
    q: '黑料每日大赛在哪里看？',
    a: '黑料每日大赛内容可以在首页「热门精选」和「焦点专题」板块找到，每日更新最新大赛精选视频，点击即可在线观看。也可通过首页「专题索引」快速定位感兴趣的大赛主题。',
  },
  {
    q: '黑料在线视频支持哪些设备观看？',
    a: '黑料在线视频全面支持电脑、平板、手机等各类设备观看。网页端适配所有主流浏览器，同时提供手机客户端下载，支持iOS和Android双平台，随时随地畅享黑料内容。',
  },
  {
    q: '黑料不打烊的内容更新频率如何？',
    a: '黑料不打烊每日更新200+条新鲜视频内容，覆盖12大话题板块。编辑团队7×24小时不间断运营，确保用户随时打开都能看到最新最热的黑料内容，真正做到不打烊。',
  },
  {
    q: '如何联系黑料平台进行投稿或反馈？',
    a: '可以通过首页「联系我们」板块获取联系方式和投稿入口。欢迎用户投稿优质内容或反馈使用建议，我们会在第一时间处理您的诉求，共同打造更好的黑料观看体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问答</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            关于黑料平台的常见问题，快速了解你想知道的一切
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-300/30 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary-500/10 flex items-center justify-center mt-0.5">
                  <span className="text-xs font-bold text-primary-400">Q</span>
                </span>
                <div className="flex-1">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900">
                    {item.q}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}